import { render, staticRenderFns } from "./AppPermissions.vue?vue&type=template&id=3bbd2598&scoped=true&"
import script from "./AppPermissions.vue?vue&type=script&lang=js&"
export * from "./AppPermissions.vue?vue&type=script&lang=js&"
import style0 from "./AppPermissions.vue?vue&type=style&index=0&id=3bbd2598&lang=scss&scoped=true&"
import style1 from "./AppPermissions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd2598",
  null
  
)

export default component.exports